'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMessageHandler = exports.createInputWithValue = exports.createChallengeForm = exports.attachChallengeIframeHorizontally = exports.attachChallengeIframeVertically = exports.createChallengeIframe = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _constants = require('./constants');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates challenge Iframe, returns iframe element
 * @returns {iframe}
 **/
var createChallengeIframe = exports.createChallengeIframe = function createChallengeIframe() {
  var challengeIframe = document.createElement('iframe');
  challengeIframe.setAttribute('id', '' + _constants.CHALLENGE_IFRAME_3DSV2);
  challengeIframe.setAttribute('name', '' + _constants.CHALLENGE_IFRAME_3DSV2);

  // set the iframe to supersede the quick-deposit loading component
  challengeIframe.style.height = '100%';
  challengeIframe.style.width = '100%';
  challengeIframe.style.position = 'absolute';
  challengeIframe.style.left = 0;
  challengeIframe.style.top = 0;

  return challengeIframe;
};

/**
 * attaches challenge Iframe with vertical styles
 * @param {iframe} challengeIframe - raw challenge iframe
 * @returns {void}
 **/
var attachChallengeIframeVertically = exports.attachChallengeIframeVertically = function attachChallengeIframeVertically(challengeIframe) {
  var styledChallengeIframe = challengeIframe;

  styledChallengeIframe.style.height = '100%';
  styledChallengeIframe.style.width = '100%';
  styledChallengeIframe.style.position = 'absolute';
  styledChallengeIframe.style.background = 'white';
  styledChallengeIframe.style.left = 0;
  styledChallengeIframe.style.top = 0;

  document.getElementsByClassName(_constants.QUICK_DEPOSIT_LOADING_SPINNER_CLASSNAME)[0].appendChild(styledChallengeIframe);
};

/**
 * attaches challenge Iframe with horizontal styles
 * @param {iframe} challengeIframe - raw challenge iframe
 * @returns {void}
 **/
var attachChallengeIframeHorizontally = exports.attachChallengeIframeHorizontally = function attachChallengeIframeHorizontally(challengeIframe) {
  var styledChallengeIframe = challengeIframe;

  styledChallengeIframe.style.height = '100%';
  styledChallengeIframe.style.width = '50%';
  styledChallengeIframe.style.position = 'absolute';
  styledChallengeIframe.style.top = '150%';
  styledChallengeIframe.style.background = 'white';

  document.getElementsByClassName(_constants.QUICK_DEPOSIT_HORIZONTAL_CLASSNAME)[0].appendChild(styledChallengeIframe);
};

/**
 * Creates challenge Form, returns form element
 * @param {string} acsUrl - url to acs
 * @returns {form}
 **/
var createChallengeForm = exports.createChallengeForm = function createChallengeForm(acsUrl) {
  var challengeForm = document.createElement('form');
  challengeForm.setAttribute('id', '' + _constants.CHALLENGE_FORM_3DSV2);
  challengeForm.setAttribute('action', '' + acsUrl);
  challengeForm.setAttribute('method', 'POST');
  challengeForm.setAttribute('target', '' + _constants.CHALLENGE_IFRAME_3DSV2);

  return challengeForm;
};

/**
 * create custom fields with predefined value inside to be able send data to server
 * @param {string} fieldName - input form name
 * @param {string} fieldValue - input form value
 * @param {boolean} isHidden - shoud hide input in form
 * @returns {ReactElement} - react input element
 **/
var createInputWithValue = exports.createInputWithValue = function createInputWithValue(fieldName, fieldValue) {
  var isHidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var threeDSSDInput = document.createElement('input');
  if (isHidden) {
    threeDSSDInput.setAttribute('type', 'hidden');
  }
  threeDSSDInput.setAttribute('name', fieldName);
  threeDSSDInput.setAttribute('value', fieldValue);

  return threeDSSDInput;
};

/**
 * creates message handler for particular iframe
 * @param {string} iframe - iframe
 * @param {string} resolve - Promise resolving function
 * @returns {Function} - message handler
 **/
var createMessageHandler = exports.createMessageHandler = function createMessageHandler(iframe, resolve) {
  return function _eventHandler(event) {
    if (event && iframe && iframe.contentWindow === event.source) {
      window.removeEventListener('message', _eventHandler, false);
      var data = (event || {}).data || {};
      resolve(data);
    }
  };
};

/**
 * Adds event listener to handle window post message
 * @param {string} iframe - iframe
 * @param {string} resolve - Promise resolving function
 * @returns {Object} - data
 **/
var addPostMessageEventListener = function addPostMessageEventListener(iframe, resolve) {
  window.addEventListener('message', createMessageHandler(iframe, resolve), false);
};

var challengeRedirection = function challengeRedirection(creq, acsUrl, threeDSSessionData) {
  return new _promise2.default(function (resolve, reject) {
    try {
      var notRemovedIframe = document.getElementById('' + _constants.CHALLENGE_IFRAME_3DSV2);

      if (notRemovedIframe !== null) {
        notRemovedIframe.remove();
      }

      var challengeIframe = createChallengeIframe();
      var challengeForm = createChallengeForm(acsUrl);

      var creqInput = createInputWithValue('creq', creq);
      challengeForm.appendChild(creqInput);

      var threeDSSDInput = createInputWithValue('threeDSSessionData', threeDSSessionData);
      challengeForm.appendChild(threeDSSDInput);

      addPostMessageEventListener(challengeIframe, resolve);
      challengeIframe.appendChild(challengeForm);

      if (document.getElementsByClassName(_constants.QUICK_DEPOSIT_VERTICAL_CLASSNAME).length > 0) {
        attachChallengeIframeVertically(challengeIframe);
      } else if (document.getElementsByClassName(_constants.QUICK_DEPOSIT_HORIZONTAL_CLASSNAME).length > 0) {
        attachChallengeIframeHorizontally(challengeIframe);
      } else {
        throw new Error('Cannot create challenge iframe');
      }

      challengeForm.submit();
    } catch (e) {
      reject((0, _utils.uniformError)(e));
    }
  });
};

exports.default = challengeRedirection;